export const calculateHotelPriceHelper = (hotel) => {
  let cheapestAvailableRoomPrice = Number.MAX_SAFE_INTEGER
  for (const roomType in hotel.realInventory) {
    if (hotel.realInventory[roomType].maxAvailablity > 0 && hotel.realInventory[roomType].minPrice < cheapestAvailableRoomPrice) {
      cheapestAvailableRoomPrice = hotel.realInventory[roomType].minPrice
    }
  }
  return Math.ceil(cheapestAvailableRoomPrice)
}
